export const signupInitialValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
};
